import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center bg-[#faf9f7] overflow-hidden px-6 py-20 lg:py-0" data-id="element-87">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-88">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col gap-6 max-w-2xl" data-id="element-89">
          <span className="inline-block px-4 py-1.5 rounded-full bg-teal-100 text-teal-800 text-sm font-medium tracking-wide w-fit" data-id="element-90">
            For high-functioning women
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-[1.15] tracking-tight" data-id="element-91">
            You're Not Lazy. <br data-id="element-92" />
            <span className="text-teal-700" data-id="element-93">You're Over-Activated.</span>
          </h1>

          <p className="text-lg md:text-xl text-slate-600 leading-relaxed max-w-lg" data-id="element-94">
            A 12-minute daily protocol to interrupt the stress loop, release
            tension, and rebuild a calm baseline without quitting your life.
          </p>

          <div className="pt-4" data-id="element-95">
            <button onClick={() => {
            document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white transition-all duration-300 bg-teal-700 rounded-lg hover:bg-teal-800 hover:scale-[1.02] shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2" data-id="element-96">
              <span data-id="element-97">Get The 14-Day Reset</span>
            </button>
            <p className="mt-3 text-sm text-slate-500" data-id="element-98">
              Instant digital download • Lifetime access
            </p>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative" data-id="element-99">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl bg-white p-2" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/my5chX3Kgp34APdSozDhmZ/14_days.png" alt="The 14-Day Nervous System Reset ebook displayed on multiple devices" className="w-full h-auto rounded-xl object-cover" data-id="element-101" />
          </div>

          {/* Decorative elements */}
          <div className="absolute -top-10 -right-10 w-64 h-64 bg-teal-100/50 rounded-full blur-3xl -z-10" data-id="element-102" />
          <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-amber-100/50 rounded-full blur-3xl -z-10" data-id="element-103" />
        </motion.div>
      </div>
    </section>;
}